import _ from '../../lodash-exports';
import { isStringFontSize, parseStringFontSize } from './parse-string-font-size';
import { isColorId, parseThemeColorId } from './parse-theme-color-id';
export const convertToStyleProperties = (properties, colorThemeMap) => {
  const styleProperties = _.mapValues({
    bgColor: searchVariantValue(variantsMapper.bgColor, properties),
    bgAlpha: searchVariantValue(variantsMapper.bgAlpha, properties),
    color: searchVariantValue(variantsMapper.color, properties),
    fontSize: searchVariantValue(variantsMapper.fontSize, properties),
    fontWeight: searchVariantValue(variantsMapper.fontWeight, properties),
    isHidden: searchVariantValue(variantsMapper.isHidden, properties),
    bgType: searchVariantValue(variantsMapper.bgType, properties)
  }, (value, key) => {
    if (isColorId(value)) {
      const themeColorId = parseThemeColorId(value);
      return colorThemeMap[themeColorId || ''];
    }
    if (isStringFontSize(value)) {
      return parseStringFontSize(value);
    }
    if (key === 'bgAlpha' && typeof value === 'string') {
      return parseFloat(value);
    }
    return value;
  });
  return _.omitBy(styleProperties, _.isNil);
};
export const variantsMapper = {
  color: ['color', 'txt'],
  bgColor: ['bg', 'background-color', 'backgroundColor', 'bgColor', 'textHighlight', 'brd', 'fillcolor', 'background'],
  bgAlpha: ['alpha-bg', 'alpha-backgroundColor', 'backgroundAlpha', 'bgAlpha'],
  fontWeight: ['font-weight', 'fontWeight', 'weight'],
  fontSize: ['font-size', 'fontSize', 'size'],
  isHidden: ['isHidden', 'hidden'],
  bgType: ['bgType']
};
const searchVariantValue = (variants, properties) => variants.map(variant => {
  const value = properties[variant];
  return typeof value === 'string' ? value.trim() : value;
}).find(Boolean);
//# sourceMappingURL=convert-to-style-properties.js.map